import React, { useEffect, useState } from 'react';
import { PillTextbox } from '../types';
import { setPillBorderRadius } from '../utils/pill-accessors';
import { usePillContent } from '../hooks/use-pill-content';
import { labelStyle, rowStyle, sectionStyle, sliderStyle, valueLabelStyle } from './pill-styles';

type Props = { pill: PillTextbox };

export const PillShapeRow: React.FC<Props> = ({ pill }) => {
  const { content, patch } = usePillContent(pill);
  const [borderRadius, setBorderRadius] = useState(0);

  useEffect(() => {
    if (content) setBorderRadius(content.borderRadius);
  }, [content]);

  const onChange = (v: number) => {
    setBorderRadius(v);
    setPillBorderRadius(pill, v); // preview
  };

  return (
    <div style={sectionStyle}>
      <div style={rowStyle}>
        <span style={labelStyle}>Esquinas</span>
        <input
          type='range'
          min={0}
          max={200}
          step={1}
          value={borderRadius}
          onChange={e => onChange(Number(e.target.value))}
          onPointerUp={() => patch({ borderRadius })}
          style={sliderStyle}
        />
        <span style={valueLabelStyle}>{Math.round(borderRadius)}px</span>
      </div>
    </div>
  );
};
